module.exports = __webpack_public_path__ + "img/kezdolap_felsoboritokep.87ff1e89.jpg";